"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  default: () => index_default,
  withPersistanceLayer: () => withPersistanceLayer
});
module.exports = __toCommonJS(index_exports);
var happened = __toESM(require("happened"));
var INGEST_EVENT_V1 = "tracking:event:ingest-api:v1";
var POSTPONED_EVENT = "tracking:event:postponed";
var GA4_EVENT_PREFIX = "event:tracking:ga4:";
var WEB_VIEW_SDK_EVENT_PREFIX = "event:web-view-sdk:";
var CHECKOUT_CONFIRM_EVENT_PREFIX = "checkout-confirm:";
var PERSISTED_EVENTS = [INGEST_EVENT_V1, POSTPONED_EVENT];
var isBrowser = typeof window !== "undefined";
var listOfEventPrefixes = [
  GA4_EVENT_PREFIX,
  WEB_VIEW_SDK_EVENT_PREFIX,
  CHECKOUT_CONFIRM_EVENT_PREFIX
];
var isArray = (value) => {
  return !!value && typeof value === "object" && Array.isArray(value);
};
var shouldUsePersistenceLayer = (eventName) => {
  const isEventMatchPrefix = listOfEventPrefixes.some(
    (eventPrefix) => eventName.startsWith(eventPrefix)
  );
  return isBrowser && (PERSISTED_EVENTS.includes(eventName) || isEventMatchPrefix);
};
var getFirstStoredEvent = (name) => {
  if (!window.__EventBusStorage) {
    return;
  }
  const events = window.__EventBusStorage[name];
  if (isArray(events) && events.length > 0) {
    return events[0];
  }
};
var triggerEvent = (callback, thisArg, eventParameters) => {
  callback.apply(thisArg, eventParameters);
};
var triggerStoredEvents = (name, callback, thisArg) => {
  if (!window.__EventBusStorage) {
    return;
  }
  const events = window.__EventBusStorage[name];
  if (isArray(events)) {
    events.forEach((eventParameters) => {
      callback.apply(thisArg, eventParameters);
    });
  }
};
var storeEvent = (name, parameters) => {
  if (!window.__EventBusStorage) {
    window.__EventBusStorage = {};
  }
  if (isArray(window.__EventBusStorage[name]) === false) {
    window.__EventBusStorage[name] = [];
  }
  window.__EventBusStorage[name].push(parameters);
};
var eventBusWithPersistenceLayer = (function() {
  const defaultBus = happened.create({
    scheduler: setImmediate
  });
  return {
    ALL_EVENTS: defaultBus.ALL_EVENTS,
    off: function(name, callback) {
      if (name === void 0) {
        defaultBus.off();
      } else {
        defaultBus.off(name, callback);
      }
    },
    trigger: function(name, ...args) {
      const parameters = args;
      if (shouldUsePersistenceLayer(name)) {
        storeEvent(name, parameters);
      }
      defaultBus.trigger(name, ...args);
    },
    on: function(name, callback, thisArg) {
      if (shouldUsePersistenceLayer(name)) {
        triggerStoredEvents(name, callback, thisArg);
      }
      defaultBus.on(name, callback, thisArg);
    },
    once: function(name, callback, thisArg) {
      if (shouldUsePersistenceLayer(name)) {
        const eventParameters = getFirstStoredEvent(name);
        if (eventParameters) {
          triggerEvent(callback, thisArg, eventParameters);
        } else {
          defaultBus.once(name, callback, thisArg);
        }
      } else {
        defaultBus.once(name, callback, thisArg);
      }
    }
  };
})();
var wrappedHappened = (function() {
  const defaultBus = happened.create({
    scheduler: setImmediate
  });
  return {
    ALL_EVENTS: defaultBus.ALL_EVENTS,
    off: function(name, callback) {
      if (name === void 0) {
        defaultBus.off();
      } else {
        defaultBus.off(name, callback);
      }
    },
    trigger: defaultBus.trigger,
    on: defaultBus.on,
    once: defaultBus.once
  };
})();
var index_default = wrappedHappened;
var withPersistanceLayer = eventBusWithPersistenceLayer;
if (typeof module !== "undefined" && module.exports) {
  module.exports = wrappedHappened;
  module.exports.withPersistanceLayer = eventBusWithPersistenceLayer;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  withPersistanceLayer
});
